<!-- ***************************************************************************************************************************** -->
<!-- Form Div for Success Metrics/Student Profile -->
<tool-form formTitle="Entry/Exit Filters">
  <form
    [formGroup]="entryExitFlowForm"
    (ngSubmit)="entryExitFlowSubmit()"
    class="form-content"
  >
    <!-- Cohort Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a cohort</mat-label>
      <mat-select formControlName="cohort">
        <mat-option *ngFor="let cohort of filters.cohorts" [value]="cohort">
          {{ cohort }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Category Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a category</mat-label>
      <mat-select
        (selectionChange)="onCategoryChange()"
        name="category"
        formControlName="category"
      >
        <mat-option selected value="College">College</mat-option>
        <mat-option value="Department">Department</mat-option>
        <mat-option value="Program">Program</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Department Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a direction</mat-label>
      <mat-select formControlName="direction">
        <mat-option value="Forward" selected>Forward</mat-option>
        <mat-option value="Backward" selected>Backward</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Select an Entry/Exit</mat-label>
      <input
        type="text"
        matInput
        formControlName="entry_exit"
        [matAutocomplete]="auto"
      />
      <button
        *ngIf="entryExitFlowForm.value.entry_exit"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="entryExitFlowForm.patchValue({ entry_exit: '' })"
      >
        <i class="fas fa-times-circle"></i>
      </button>
      <mat-error *ngIf="this.entryExitFlowForm.controls['entry_exit'].invalid"
        >You must select a value</mat-error
      >
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option
          *ngFor="let option of entryExitOptions | async"
          [value]="option"
        >
          {{ option }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- High School GPA Input -->
    <div class="form-slider-container">
      <mat-label class="form-slider-text-label">High School GPA</mat-label>
      <mat-slider class="form-slider" min="0" max="5.04" step="0.5">
        <input
          value="0"
          matSliderStartThumb
          #sliderStart
          formControlName="hs_gpa_lower"
        />
        <input
          value="5.04"
          matSliderEndThumb
          #sliderEnd
          formControlName="hs_gpa_upper"
        />
      </mat-slider>
      <div class="form-slider-value-label-container">
        <label class="example-value-label">{{ sliderStart.value }}</label>
        <label class="example-value-label">{{ sliderEnd.value }}</label>
      </div>
    </div>

    <!-- Year Range Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Year Range</mat-label>
      <mat-select formControlName="year_range">
        <mat-option value="One2Two" selected>From 1 to 2</mat-option>
        <mat-option value="Two2Three" selected>From 2 to 3</mat-option>
        <mat-option value="Three2Four" selected>From 3 to 4</mat-option>
        <mat-option value="Four2End" selected>From 4 to end</mat-option>
        <mat-option value="One2End" selected>From 1 to end</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Submit Button -->
    <tool-form-action-button
      text="Submit"
      [disabled]="!isValidForm()"
      (onClick)="closeDialog()"
    ></tool-form-action-button>
  </form>
</tool-form>
